import { Flip } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(Flip, ScrollTrigger);

export default class UIFlip extends DefaultBlock {
	init() {
		this.DOM = {
			wrapper: this.block.querySelector(".ui-flip__wrapper"),
		};
		this.animating = false;

		this.initEvents();
	}

	initEvents() {
		ScrollTrigger.create({
			trigger: "#flip-container",
			start: "top 85%",
			once: true,
			simple: true,
			onEnter: () => this.open(),
		});

		this.DOM.wrapper.addEventListener("click", () => {
			if (this.DOM.wrapper.classList.contains("reorder")) {
				this.close();
			} else {
				this.open();
			}
		});
	}

	open() {
		if (this.animating) return;

		this.animating = true;

		const startState = Flip.getState(
			"#flip-wrapper, #flip-circle, #flip-lines, #flip-line1, #flip-line2, #flip-line3"
		);

		this.DOM.wrapper.classList.add("reorder");

		Flip.from(startState, {
			duration: 1.4,
			ease: "power4.inOut",
			nested: true,
			onComplete: () => {
				this.animating = false;
			},
		});
	}

	close() {
		if (this.animating) return;

		this.animating = true;

		const startState = Flip.getState(
			"#flip-wrapper, #flip-circle, #flip-lines, #flip-line1, #flip-line2, #flip-line3"
		);

		this.DOM.wrapper.classList.remove("reorder");

		Flip.from(startState, {
			duration: 1.4,
			ease: "power4.inOut",
			nested: true,
			absolute: true,
			simple: true,
			onLeave: (elements) =>
				gsap.fromTo(
					elements,
					{ transformOrigin: "50% 0%", scaleY: 1 },
					{ scaleY: 0, duration: 0.2, ease: "power2.in" }
				),
			onComplete: () => {
				this.animating = false;
			},
		});
	}
}
